import React from 'react';
import { Box, Stack } from '@mui/material';
import { ArrowDropUp, ArrowDropDown } from '@mui/icons-material';
import makeStyles from '@mui/styles/makeStyles';
import PropTypes from 'prop-types';
import i18n from 'i18next';

const useStyles = makeStyles((theme) => ({
    root: {
        background: theme.palette.documentViewer.spellContainerBackgroundColor,
        borderTopLeftRadius: '8px',
        borderBottomLeftRadius: '8px',
        paddingTop: '10px',
        paddingLeft: '10px',
        paddingBottom: '10px',
        borderRightWidth: '6px',
        borderRightStyle: 'solid',
        borderRightColor: theme.palette.background.default,
        '&.expanded': {
            paddingBottom: '0px',
        },
    },
    header: {
        position: 'relative',
    },
    containerName: {
        color: theme.palette.documentViewer.contrastTextColor,
        fontFamily: 'Inter',
        fontSize: '18px',
        fontStyle: 'normal',
        fontWeight: '700',
    },
    containerDate: {
        color: theme.palette.documentViewer.lowContrastTextColor,
        fontFamily: 'Inter',
        fontSize: '14px',
        fontStyle: 'normal',
        fontWeight: '400',
    },
    containerHeaderRightSIde: {
        position: 'absolute',
        background: theme.palette.documentViewer.spellContainerBackgroundColor,
        width: '8px',
        borderTopRightRadius: '8px',
        borderBottomRightRadius: '8px',
        height: 'calc(100% + 10px)',
        right: '-5px',
        top: '-10px',
    },
    containerLeftSide: {
        paddingLeft: '8px',
    },
    container: {
        padding: '6px',
        marginLeft: '-10px',
        marginRight: '-10px',
        marginBottom: '-10px',
        borderTopLeftRadius: '8px',
        background: theme.palette.documentViewer.spellContainerGroupBackgroundColor,
    },
    collapseSwitch: {
        height: '24px',
        cursor: 'pointer',
    },
}));

export default function SpellContainer(props) {
    const classes = useStyles();
    const [spellExpanded, setSpellExpanded] = React.useState(props.defaultExpanded);

    return (
        <Box className={`${classes.root} ${spellExpanded ? '' : 'expanded'}`}>
            <Box className={classes.header}>
                <Stack direction={'row'} justifyContent={'space-between'} alignItems={'top'}>
                    <Stack direction={'column'} paddingBottom={'10px'}>
                        <Box className={classes.containerName}>{props.name}</Box>
                        <Box className={classes.containerDate}>{`(${props.startDate} - ${props.endDate})`}</Box>
                    </Stack>
                    <Box className={classes.collapseSwitch} onClick={() => setSpellExpanded(!spellExpanded)}>
                        {spellExpanded ? <ArrowDropUp /> : <ArrowDropDown />}
                    </Box>
                </Stack>
                <Box className={classes.containerHeaderRightSIde}></Box>
            </Box>
            {spellExpanded && (
                <Box className={classes.containerLeftSide}>
                    <Stack direction={'column'} gap={'6px'} className={classes.container}>
                        {props.children}
                    </Stack>
                </Box>
            )}
        </Box>
    );
}

SpellContainer.defaultProps = {
    name: '-',
    startDate: i18n.t('Not Set', 'Not Set') !== undefined ? i18n.t('Not Set', 'Not Set') : 'Not Set',
    endDate: i18n.t('Outgoing', 'Outgoing') !== undefined ? i18n.t('Outgoing', 'Outgoing') : 'Outgoing',
    defaultExpanded: true,
};

SpellContainer.propTypes = {
    name: PropTypes.string,
    startDate: PropTypes.string,
    endDate: PropTypes.string,
    defaultExpanded: PropTypes.bool,
};
